import { render, staticRenderFns } from "./perfect-cheliang-dialog.vue?vue&type=template&id=32cabe13&scoped=true"
import script from "./perfect-cheliang-dialog.vue?vue&type=script&lang=js"
export * from "./perfect-cheliang-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cabe13",
  null
  
)

export default component.exports